/**
 * Fragment de routes du paquet v6-p02-anomalies-qualite (vague V6, règle R2 du découpage V4–V11 : un fragment par paquet).
 * Composants chargés à la demande (règle de chargement du registre), aucun code exécuté au chargement.
 * Route du socle remplacée (`remplace: true`), d'après le `couvre: route:/qualite` du YAML de projet-qualite : l'écran
 * historique `screens/qualite/TableauBordQualite` n'est plus servi ; son fichier et App.tsx (gelé) restent inchangés.
 * Routes neuves (écrans pleins ; projet par `?projet=`, anomalie par `?anomalie=`, mission par `?mission=`) :
 *  - `/anomalies/declarer` (dialogue-creer-anomalie), `/anomalies/contexte` (dialogue-completer-anomalie),
 *    `/anomalies/etat` (dialogue-changer-etat-anomalie), `/anomalies/echec` (projet-echec-mission-fiche).
 */
import { lazy, Suspense, type ComponentType, type JSX } from 'react'

import type { Session } from '../../auth/session'
import type { ContexteRoutes, FragmentRoutes } from './registre'

const ProjetQualite = lazy(() => import('../ecrans/v6/anomalies/ProjetQualite'))
const DialogueCreerAnomalie = lazy(() => import('../ecrans/v6/anomalies/DialogueCreerAnomalie'))
const DialogueCompleterAnomalie = lazy(() => import('../ecrans/v6/anomalies/DialogueCompleterAnomalie'))
const DialogueChangerEtatAnomalie = lazy(() => import('../ecrans/v6/anomalies/DialogueChangerEtatAnomalie'))
const ProjetEchecMissionFiche = lazy(() => import('../ecrans/v6/anomalies/ProjetEchecMissionFiche'))

function ecran(Composant: ComponentType<{ session: Session }>) {
  return ({ session, t }: ContexteRoutes): JSX.Element => (
    <Suspense fallback={<p role="status">{t('v10.primitives.assemblage.chargement')}</p>}>
      <Composant session={session} />
    </Suspense>
  )
}

export const fragment: FragmentRoutes = {
  zone: 'v6-anomalies',
  routes: [
    { chemin: '/qualite', element: ecran(ProjetQualite), remplace: true },
    { chemin: '/anomalies/declarer', element: ecran(DialogueCreerAnomalie) },
    { chemin: '/anomalies/contexte', element: ecran(DialogueCompleterAnomalie) },
    { chemin: '/anomalies/etat', element: ecran(DialogueChangerEtatAnomalie) },
    { chemin: '/anomalies/echec', element: ecran(ProjetEchecMissionFiche) },
  ],
}
